import React, {Component} from 'react'
import { Query } from 'react-apollo'
import {withStyles} from '@material-ui/core/styles/index'
import classNames from 'classnames'
import {Button} from '@material-ui/core'
import InputOutlined from '@material-ui/icons/InputOutlined'
import {withRouter, Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {get} from 'lodash'
import {logout} from '../utils'

import { MESSAGE_USAGE } from '../graphql/query'
import { MESSAGE_USAGE_POLL_INTERVAL } from '../config'

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  seperator: {
    width: 1,
    height: 64,
    backgroundColor: theme.palette.divider,
  },
})

const navButtonStyle = {
  color: '#F9FDFF',
  border: 'none',
  fontSize: '14px',
}

const navProfileStyle = {
  color: '#F9FDFF',
  border: 'none',
  fontSize: '14px',
  textTransform: 'none',
}

class MainToolbar extends Component {
  async logout() {
    logout()
  }

  render() {
    const {classes, user} = this.props
    const email = get(user, 'selectedProject.email', '')
    const projectId = get(user, 'selectedProject.projectId')

    return (
      <div
        className={classNames(classes.root, 'flex flex-row')}
        style={{justifyContent: 'flex-end', color: '#F9FDFF', fontSize: '12px'}}
      >
        <div className="flex items-center" style={{marginRight: '2em'}}>
          {projectId && (
            <Query
              pollInterval={MESSAGE_USAGE_POLL_INTERVAL}
              query={MESSAGE_USAGE}
              variables={{ projectId }}
            >
              {
              ({loading, data}) => {
                const currentUsage = get(data, 'getProject.currentMonthlyMessageUsage', 0)
                const quota = get(data, 'getProject.monthlyMessageQuota', 0)
                return <div>{!loading ? `Message Usage: ${currentUsage.toLocaleString()}/${quota.toLocaleString()}` : ''}</div>
              }
            }
            </Query>
          )}
          <Link to={`/project/${projectId}/profile`}>
            <Button style={navProfileStyle}>{email}</Button>
          </Link>
          <Button style={navButtonStyle} onClick={this.logout}>
            <InputOutlined />
          </Button>
        </div>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch)
}

function mapStateToProps({fuse, auth}) {
  return {
    user: auth.user,
  }
}

export default withStyles(styles, {withTheme: true})(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(MainToolbar),
  ),
)



// WEBPACK FOOTER //
// ./src/main/MainToolbar.js